<template>
  <v-container>
    <h4>Personal Information</h4>
    <v-row>
      <v-col
        cols="4"
        md="2"
      >
        <p>Firstname:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.firstname || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Lastname:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.lastname || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Display name/nickname:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.display_name || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Active:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.active ? 'Yes' : 'No' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Email:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.email || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Phone number:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.phone_number || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Line ID:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.line_id || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Facebook:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ customer.facebook_name || '-' }}</p>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'PersonalInformation',
  components: { },
  props: ['customer', 'image_src'],
  data: () => ({ }),
  methods: { }
}
</script>

<style scoped>
</style>